"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.queryOperatorSet = void 0;
exports.queryOperatorSet = new Set([
    'eq',
    'gt',
    'gte',
    'lt',
    'lte',
    'between',
    'beginsWith'
]);
